import useAlias from '@alias';
import { EditUserFormValues } from '@hooks/api/mutations/useUserUpdate';
import { Checkbox, FormControlLabel } from '@mui/material';
import { useFormContext } from 'react-hook-form';

interface MfaRequiredFieldProps {
  totp?: boolean;
}

function MfaRequiredField({ totp }: MfaRequiredFieldProps) {
  const alias = useAlias();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { setValue } = useFormContext<EditUserFormValues>();

  return (
    <FormControlLabel
      control={
        <Checkbox
          defaultChecked={totp}
          onChange={(e) => setValue('totp', e.target.checked)}
          size='small'
        />
      }
      label={alias('MFA Required')}
    />
  );
}

export default MfaRequiredField;
